import { gql } from '@apollo/client';

export const createOffenseMutation = gql`
  mutation createOffense($object: String!, $id: ID!, $content: String!, $email: String!) {
    createOffense(object: $object, id: $id, content: $content, email: $email) {
      createdAt
    }
  }
`;
